<template>
    <div style="position:relative">
        <div :style="spinShow?'height:100vh':''">
            <ul class="product clearfix" v-if="product.length">
                <li class="content">
                    <left-image v-if="productImage.detailImageList" :imageList="productImage.detailImageList" />
                </li>
                <!-- 右参数 -->
                <li class="content contentText">
                    <h2>{{product.productName}}&nbsp;({{product.productDesc}})</h2>
                    <ul class="price">
                        <li class="priceItem">
                            <span style="color:#828080;font-size:16px">日租金</span>
                            <span style="color:#ff9000;padding-left:10px">
                                <b>￥</b><b style="color:#ff9000;font-size:20px;padding-left:5px ">{{product.displayUnitRental}}/天起</b>
                            </span>
                        </li>
                        <li class="priceItem">
                            <span style="color:#828080;font-size:16px;">起租数：</span>
                            <strong style="color:#ff9000;font-size:23px;padding-left:10px ">{{product.minPurchaseQty}}</strong>
                        </li>
                    </ul>
                    <div class="topTab">
                        <div v-for="(chargeMode, index) in chargeModeList" :key="index" :class="modeIndex == index ? 'checkedMode' : '' " @click="rentalList = chargeMode.rentalList; modeIndex = index">
                            <b>{{chargeMode.priceModeId}}</b>
                        </div>
                    </div>
                    <div class="dailyRental">

                        <table class="tableStyle" width="98%" border="1" cellpadding="0" cellspacing='0'>
                            <tr>
                                <td>租赁期限</td>
                                <td>日租金</td>
                                <td>日服务费</td>
                            </tr>
                            <tr v-for="(rental, index) in rentalList" :key="index">
                                <td>{{rental.startDay}}-{{rental.endDay}}</td>
                                <td>{{rental.unitRentalFee}}元/天</td>
                                <td>{{rental.unitServiceFee}}元/天</td>
                            </tr>
                        </table>
                    </div>
                    <ul class="specifications">
                        <li class="specifica">
                            <p>尺寸</p>
                            <div class="text">{{product.length}}mm*{{product.width}}mm*{{product.height}}mm</div>
                        </li>
                        <li class="specifica" style="margin-left:50px">
                            <p>重量</p>
                            <div class="text" style="margin-left:25px">{{product.weight}}kg</div>
                        </li>
                    </ul>

                    <ul class="specifications">
                        <li class="specifica deadLoad">
                            <p style="margin-right:20px">额定载荷</p>
                            <ul class="dynamicLoad">
                                <li>静载 {{product.deadLoad}}kg</li>
                                <li>动载 {{product.dynamicLoad}}kg</li>
                                <li v-if="product.shelfLoad">货架 {{product.shelfLoad}}kg</li>
                            </ul>

                        </li>
                    </ul>
                    <ul class="specifications">
                        <li class="specifica">
                            <p>工艺</p>
                            <div class="text">{{$options.filters['queryDict']('target', 'processTech', product.processTech)}}&nbsp;|&nbsp;{{$options.filters['queryDict']('target', 'moldTech', product.moldTech)}}</div>
                        </li>
                    </ul>
                    <ul class="specifications">
                        <li class="quantity">
                            <p>数量</p>
                            <div class="quantityInput">
                                <ul>
                                    <li>
                                        <input type="number" v-model="order.quantity" min="1" :max="maxVal" @blur="order.quantity = Math.max(order.quantity, product.minPurchaseQty)">
                                    </li>
                                    <li>
                                        <p class="top" @click="onPush">
                                            <Icon class="iconfont" type="ios-arrow-up" />
                                        </p>
                                        <p class="bottom" @click="onMinus" v-if="order.quantity>1">
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                        <p class="bottom disable" v-else>
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                    <div class="specifications">
                        <div class="specifica">
                            <p>起租日期</p>
                            <div class="text addrCascader" style="margin-left:20px">
                                <DatePicker :options="options" type="date" v-model="order.leaseBeginDate" @on-change="onBeginDate" placeholder="请选择日期" style="width: 200px"></DatePicker>
                            </div>

                        </div>
                    </div>
                    <ul class="specifications">
                        <li class="quantity">
                            <p>租赁期限</p>
                            <div class="quantityInput" style="margin-left:20px">
                                <ul>
                                    <li>
                                        <input type="number" v-model="order.tenancy" min="1" :max="maxVal">
                                    </li>
                                    <li>
                                        <p class="top" @click="onPushTenancy">
                                            <Icon class="iconfont" type="ios-arrow-up" />
                                        </p>
                                        <p class="bottom" @click="onMinusTenancy" v-if="order.tenancy>1">
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                        <p class="bottom disable" v-else>
                                            <Icon class="iconfont" type="ios-arrow-down" />
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>

                    <ul class="specifications">
                        <li class="specifica">
                            <p>预估租金</p>
                            <div class="text totalFee">￥{{totalFee}}</div>
                        </li>
                    </ul>
                    <div style="margin: 30px">
                        <Button type="warning" size="large" style="width: 120px" @click="goHire">立即租托</Button>
                    </div>
                </li>
            </ul>

            <!-- tab -->
            <div class="descImage">
                <tabs :tabList="tabList" id="tabs" @onActive="onActive" :tabsTop="1091" width="1080px"></tabs>
                <div class="detail">
                    <div v-show="tabShow === 'imgDesc'">
                        <img-desc :descImageList="productImage.descImageList" />
                    </div>
                    <div v-show="tabShow === 'businessFlow'">
                        <business-flow />
                    </div>

                </div>
            </div>
        </div>
        <qrcode-product :qrCode="productImage.qrCode"/>
        <on-hire ref="onHireRef" />
        <my-spin :spinShow="spinShow" />

    </div>
</template>

<script>
import leftImage from '@/views/mall/product-details/left-image.vue';
import radio from 'components/radio.vue';
import addrCascader from 'components/select/addr-cascader.vue';
import tabs from '@/views/mall/product-details/component/tabs.vue'
import imgDesc from './componet/imgDesc.vue';
import businessFlow from './componet/businessFlow.vue'
import mySpin from '_c/app-component/mySpin.vue'

import onHire from './componet/onHire.vue'
import qrcodeProduct from '_c/app-component/qrcode-product'//商品二维码

export default {
    name: "leaseDetail",
    components: { leftImage, radio, addrCascader, tabs, imgDesc, businessFlow, onHire, mySpin,qrcodeProduct },
    data() {
        return {
            spinShow: true,
            maxVal: 99999,
            tabShow: 'imgDesc',
            product: {},
            productImage: {},
            chargeModeList: [],
            tabList: [
                { title: '产品详情', desc: 'imgDesc' },
                { title: '业务流程', desc: 'businessFlow' },
            ],
            deliveryOptions: [
                { text: '配送上门', value: 'Y' },
                { text: '货物自提', value: 'N' },
            ],
            order: {
                deliveryMethod: '',
                quantity: 1,
                leaseBeginDate: '',
                tenancy: 1,
            },
            rentalList: [],
            modeIndex: 0,
            options: {
                disabledDate(date) {
                    return date && date.valueOf() < Date.now();
                }
            },
            successLoad: false,
        }
    },
    computed: {
        totalFee: function () {
            let { tenancy, quantity } = this.order;

            let fee = 0;

            this.rentalList.some(({ startDay, endDay, unitRentalFee, unitServiceFee }) => {

                let timeSpan = Math.min(tenancy, endDay) - +startDay + 1;
                fee += timeSpan * (unitRentalFee * 100 + unitServiceFee * 100);

                return endDay > tenancy;
            })

            return (fee * quantity) / 100;
        },

    },
    async beforeCreate() {
        await this.dict.initDict([
            { id: 'processTech', namespace: 'target' },
            { id: 'moldTech', namespace: 'target' },
        ]);
    },
    mounted() {

        this.product.productId = this.$route.query.productId;

        Promise.all([

            this.queryProductConfiguration(),
            this.queryProductImage(),
            this.queryChargeMode()

        ]).then(() => { this.successLoad = true; });
    },
    methods: {
        // 立即下单
        async goHire() {
            let sessionId = this.pltSession.getSession()
            if (!sessionId) {
                await this.showConfirm('提示', '您还未登录, 去登录?')
                this.$router.push('/login');
                this.$store.commit('anonymous/setPath', { query: { productId: this.product.productId }, to: '/lease-product-details' });
                return;
            }
            let data = {
                productId: this.product.productId,
                tenancy: this.order.tenancy,
                leaseBeginDate: this.order.leaseBeginDate,
                quantity: this.order.quantity,
                minPurchaseQty: this.product.minPurchaseQty,
                chargeModeList: this.chargeModeList,
                priceModeId: this.chargeModeList[this.modeIndex].priceModeId
            }
            this.$refs['onHireRef'].openModal(data)
        },
        onBeginDate(val) {
            this.order.leaseBeginDate = val;
        },
        onActive(params) {
            this.tabShow = params
        },
        onPush() {
            if (this.order.quantity > this.maxVal) {
                this.order.quantity = this.maxVal

            } else {
                this.order.quantity++
            }
        },
        onMinus() {
            this.order.quantity--
        },
        onPushTenancy() {
            if (this.order.tenancy > this.maxVal) {
                this.order.tenancy = this.maxVal

            } else {
                this.order.tenancy++
            }
        },
        onMinusTenancy() {
            this.order.tenancy--
        },
        async queryProductConfiguration() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryProductConfigByProductId",
                body: { productId: this.product.productId }
            }
            await this.invoke(param).then(rs => {
                this.product = rs;
            })

            let targetCode = this.product.targetModelCode;

            let param2 = {
                url: 'http://CORE-TARGET/messageService/baseInfoService/queryTargetConfigurationByTargetCode',
                body: { targetCode }
            };
            this.invoke(param2).then(model => {
                this.product = { ...this.product, ...model }
                this.order.quantity = this.product.minPurchaseQty;
            })

        },
        queryProductImage() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryProductImage",
                body: { productId: this.product.productId }
            }
            this.invoke(param).then(rs => {
                this.productImage = rs;
            })
        },
        queryChargeMode() {
            let param = {
                url: "http://MID-CLIENT-MALL/messageService/productService/queryChargeModeByProductId",
                body: { productId: this.product.productId }
            }
            this.invoke(param).then(rs => {
                this.spinShow = false
                this.chargeModeList = rs;
                this.rentalList = rs[0].rentalList;
            })

        }
    }
}
</script>
<style lang="scss" scoped>
.product {
    margin-top: 20px;
    .content {
        float: left;
    }
    .contentText {
        width: 625px;
        margin-left: 20px;
        .price {
            width: 625px;
            height: 45px;
            background: #ecebeb;
            margin: 20px 0;
            line-height: 45px;
            .priceItem {
                float: left;
                margin-left: 30px;
            }
        }
        // tab
        .topTab {
            width: 583px;
            display: flex;
            border: 1px solid #c4c1c1;
            margin: 30px 0 0 30px;
            div {
                padding: 5px 15px;
                &:hover {
                    cursor: pointer;
                }
            }
        }
        .dailyRental {
            margin: 20px 0 0 30px;
            .tableStyle {
                border: 1px solid #c4c1c1;

                tr {
                    border: 1px solid #c4c1c1;
                    text-align: center;

                    td {
                        width: 177px;
                        height: 48px;
                        border: 1px solid #c4c1c1;
                    }
                }
            }
        }
        .specifications {
            width: 582px;
            margin: 30px 0 0 30px;
            display: flex;
            // flex-direction: row;
            // justify-content: space-between;
            .specifica {
                // height: 37px;
                line-height: 37px;
                p,
                div {
                    float: left;
                }
                .text {
                    height: 35px;
                    line-height: 35px;
                    padding: 0 10px;
                    border: 2px solid #c4c1c1;
                    margin-left: 47px;
                }
            }
            .deadLoad {
                .dynamicLoad {
                    display: flex;
                    margin-left: 20px;
                    border: 2px solid #c4c1c1;

                    li {
                        width: 145px;
                        height: 35px;
                        text-align: center;
                        line-height: 35px;
                        border-right: 2px solid #c4c1c1;
                    }
                    li:last-child {
                        border-color: transparent;
                    }
                }
            }
            .quantity {
                > p {
                    float: left;
                    margin-top: 5px;
                }
                .quantityInput {
                    float: left;
                    margin-left: 47px;
                    ul {
                        display: flex;
                        li:first-child {
                            input {
                                width: 72px;
                                height: 35px;
                                border: 2px solid #c4c1c1;
                                text-align: center;
                                outline: none;
                            }
                            input::-webkit-outer-spin-button,
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none;
                            }
                            input[type="number"] {
                                -moz-appearance: textfield;
                            }
                        }
                        li:last-child {
                            margin-left: 10px;
                            .top {
                                margin-bottom: 5px;
                            }
                            .disable {
                                cursor: not-allowed !important;
                            }
                            .top,
                            .bottom {
                                text-align: center;
                                width: 22px;
                                height: 15px;
                                border: 1px solid #c4c1c1;
                                line-height: 15px;
                                font-size: 16px;
                                -moz-user-select: none; /*火狐*/
                                -webkit-user-select: none; /*webkit浏览器*/
                                -ms-user-select: none; /*IE10*/
                                -khtml-user-select: none; /*早期浏览器*/
                                user-select: none;
                                color: #ccc;
                                &:hover {
                                    cursor: pointer;
                                    border-color: #ff8800;
                                }
                                &:hover .iconfont {
                                    color: #ff8800;
                                }
                            }
                        }
                    }
                }
            }
        }
        .specifications .specifica .addrCascader {
            height: 35px;
            line-height: 35px;
            /deep/ .ivu-input {
                font-size: 16px;
                background: transparent;
                color: #333;
                outline: none;
                height: 35px;
                border-color: transparent;
                padding-bottom: 7px;
                &:hover {
                    border-color: transparent;
                }
            }
            /deep/ .ivu-input:focus {
                border-color: transparent;
                outline: transparent;
                box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
            }
            /deep/ .ivu-date-picker-focused input {
                border-color: transparent;
                outline: transparent;
                box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.1);
            }
        }
        .textInput {
            width: 582px;
            margin: 30px 0 0 30px;
            .addrad {
                p {
                    margin-top: 5px;
                }
                p,
                div {
                    float: left;
                }
                div {
                    margin-left: 20px;
                    input {
                        width: 224px;
                        height: 35px;
                        line-height: 35px;
                        outline: none;
                        border: 2px solid #c4c1c1;
                        padding-left: 10px;
                    }
                }
            }
        }
        .specifications .specifica .totalFee {
            color: #ff8800;
            font-size: 18px;
            font-weight: bold;
            border-color: transparent;
            margin-left: 10px;
        }
    }
}
.descImage {
    margin-top: 30px;
    .detail {
        margin-top: 30px;
    }
}

.checkedMode {
    color: #fff;
    background: #ff8800;
}
</style>